var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('search-result-header',{attrs:{"keyword":_vm.params.keyword,"show-tabs":false},on:{"search":_vm.searchCurrentPage}}),_c('goodslist-body',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = []

export { render, staticRenderFns }